import {z} from 'zod';

const OrganizeAssetsWarningObjectItemAssetSchema = z.object({
	assetId: z.number().min(1),
	creationDate: z.string().refine((date) => !isNaN(Date.parse(date)), {
		message: 'Invalid date',
	}),
	/**
	 * Indicates whether the file(name) already exists in the target category
	 * * `true`: is a conflicting asset
	 * * `false`: is the asset being organized
	 */
	existing: z.boolean(),
	fileSize: z.number().min(0),
	name: z.string().min(2).max(100),
	thumbUrl: z.string().url(),
});

export type IOrganizeAssetsWarningObjectItemAsset = z.infer<
	typeof OrganizeAssetsWarningObjectItemAssetSchema
>;

const OrganizeAssetsWarningObjectItemSchema = z.object({
	fileName: z.string(),
	assets: z.array(OrganizeAssetsWarningObjectItemAssetSchema),
});

export type IOrganizeAssetsWarningObjectItem = z.infer<
	typeof OrganizeAssetsWarningObjectItemSchema
>;

const OrganizeAssetsWarningObjectSchema = z.object({
	collisions: z.array(OrganizeAssetsWarningObjectItemSchema),
});

export type IOrganizeAssetsWarningObject = z.infer<
	typeof OrganizeAssetsWarningObjectSchema
>;
